/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 10/02/2023
 */
import React, { useState, useRef, useEffect } from "react";
import "./ImageUpload.styles.scss";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { IconButton, Tooltip } from "@mui/material";
import buildings from "../../../../resources/buildings.png";

const ImageUpload = ({ tooltip, setProfilePic, orgLogo }) => {
  const [pic, setpic] = useState(buildings);

  useEffect(() => {
    if (orgLogo) {
      setpic("data:image/png;base64," + orgLogo);
    }
  }, [orgLogo]);

  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setpic(e.target.result);
      };

      reader.readAsDataURL(e.target.files[0]);
      setProfilePic(e.target.files[0]);
    }
  };

  const handleUploadButtonClick = () => {
    // Trigger the file input when the upload button is clicked
    fileInputRef.current.click();
  };

  return (
    <div className="imageUploader">
      <div className="circle">
        <img className="profile-pic" src={pic} alt="Profile" />
      </div>
      <div className="p-image">
        <Tooltip arrow placement="right" title={tooltip}>
          <IconButton
            className="upload-button"
            onClick={handleUploadButtonClick}
            sx={{ marginTop: -3 }}>
            <AddAPhotoIcon />
          </IconButton>
        </Tooltip>
        <input
          ref={fileInputRef}
          className="file-upload"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
        />
      </div>
    </div>
  );
};

export default ImageUpload;
